// Permisos RBAC de la pantalla Cobranza. Sin `loan.credit.read` la pantalla no se muestra y el
// item del sidebar queda oculto: el listado de cuotas responde 403.

/** Va como `string`: `PermissionKey`, generado del OpenAPI, no expone claves de dominio. */
export const INSTALLMENTS_PERMISSIONS = {
    readCredit: 'loan.credit.read',
} as const;

export type InstallmentsPermissionKey =
    (typeof INSTALLMENTS_PERMISSIONS)[keyof typeof INSTALLMENTS_PERMISSIONS];

export interface InstallmentsAbilities {
    canReadCredit: boolean;
}

/**
 * Toma el set de permisos como `ReadonlySet<string>` —y no como `PermissionKey`— porque el union
 * generado del OpenAPI no incluye las claves de dominio: comparar contra él no compila.
 */
export function resolveInstallmentsAbilities(
    grantedPermissions: ReadonlySet<string>,
): InstallmentsAbilities {
    return { canReadCredit: grantedPermissions.has(INSTALLMENTS_PERMISSIONS.readCredit) };
}
